import { render, staticRenderFns } from "./PV.vue?vue&type=template&id=5251d9d8&scoped=true"
import script from "./PV.vue?vue&type=script&lang=js"
export * from "./PV.vue?vue&type=script&lang=js"
import style0 from "./PV.vue?vue&type=style&index=0&id=5251d9d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5251d9d8",
  null
  
)

export default component.exports